import { createValidIcon } from '@ui/icons/utils/type-helper'

export const PlaceholderIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid='placeholder-icon'
    >
      <path
        d='M9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.27208 15.75 2.25 12.7279 2.25 9C2.25 5.27208 5.27208 2.25 9 2.25Z'
        fill={color}
      />
    </svg>
  )
})
